export class TermCondition{
  public static readonly  PATH_FILE = '../../../../../../assets/terms/';
}
